import LoginController from './LoginController';
import LoginDaisyService from './services/LoginDaisyService';

const module = angular.module('myApp.login', []);
module.service('loginDaisyService', LoginDaisyService);
module.controller('LoginController', LoginController);